<template>
  <!-- 产品中心 -->
  <div class="container">
    <Menu :page="1"></Menu>
    <section class="section product">
      <div class="title">
        <h1>
          <p>小π企业管理5大体系</p>
          <p>核心功能</p>
        </h1>
      </div>
      <div class="fun-wrap">
        <div class="module-wrap" v-for="(item, index) in funList" :key="index">
          <h2 class="module-title">{{ item.title }}</h2>
          <div class="cell-wrap flex-row">
            <div
              class="cell"
              v-for="(n, nIndex) in item.list"
              :key="nIndex"
              @click="goProductDetail(n)"
            >
              <img :src="n.img" />
              <p>{{ n.title }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <Footer></Footer>
  </div>
</template>

<script>
import Menu from "@/components/menu.vue";
import Footer from "@/components/footer.vue";
export default {
  components: {
    Menu,
    Footer,
  },
  data() {
    return {
      funList: [
        {
          title: "协同办公",
          list: [
            {
              title: "即时通讯",
              type: "1",
              img: require("@/assets/images/im.png"),
            },
            {
              title: "邮箱",
              type: "2",
              img: require("@/assets/images/youxiang.png"),
            },
            {
              title: "云盘",
              type: "3",
              img: require("@/assets/images/yunpan.png"),
            },
            {
              title: "在线文档",
              type: "4",
              img: require("@/assets/images/zaixian.png"),
            },
          ],
        },
        {
          title: "人力资源",
          list: [
            {
              title: "组织架构",
              type: "5",
              img: require("@/assets/images/jiagou.png"),
            },
            {
              title: "人事管理",
              type: "6",
              img: require("@/assets/images/renshi.png"),
            },
            {
              title: "招聘",
              type: "7",
              img: require("@/assets/images/zhaoping.png"),
            },
            {
              title: "考勤假期",
              type: "8",
              img: require("@/assets/images/kaoqin.png"),
            },
            {
              title: "OA审批",
              type: "9",
              img: require("@/assets/images/oa.png"),
            },
            {
              title: "绩效考核",
              type: "10",
              img: require("@/assets/images/jixiao.png"),
            },
            {
              title: "智能薪酬",
              type: "11",
              img: require("@/assets/images/xinchou.png"),
            },
          ],
        },
        {
          title: "企业文化",
          list: [
            {
              title: "企业新闻",
              type: "12",
              img: require("@/assets/images/news.png"),
            },
            {
              title: "行业资讯",
              type: "13",
              img: require("@/assets/images/zixun.png"),
            },
            {
              title: "电子内刊",
              type: "14",
              img: require("@/assets/images/neikan.png"),
            },
            {
              title: "好友动态",
              type: "15",
              img: require("@/assets/images/haoyou.png"),
            },
            {
              title: "月光宝盒",
              type: "16",
              img: require("@/assets/images/yueguang.png"),
            },
          ],
        },
        {
          title: "行政管理",
          list: [
            {
              title: "资产管理",
              type: "17",
              img: require("@/assets/images/xingzhen.png"),
            },
            {
              title: "文件用印",
              type: "18",
              img: require("@/assets/images/file.png"),
            },
            {
              title: "群管理",
              type: "19",
              img: require("@/assets/images/qgl_icon.png"),
            },
            {
              title: "系统消息",
              type: "20",
              img: require("@/assets/images/xtxx_icon.png"),
            },
            {
              title: "检举揭发",
              type: "21",
              img: require("@/assets/images/jjjf_icon.png"),
            },
          ],
        },
        {
          title: "业务培训",
          list: [
            {
              title: "商学院",
              type: "22",
              img: require("@/assets/images/shangxuey.png"),
            },
            {
              title: "视频会议",
              type: "23",
              img: require("@/assets/images/file.png"),
            },
          ],
        },
      ],
    };
  },
  methods: {
    goProductDetail(item) {
      this.$router.push({ path: "/productDetail", query: { type: item.type } });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  .section {
    &.product {
      padding: 40px 25px 95px;
      background-image: url("../../assets/images/product_bg.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      .title {
        text-align: center;
        font-size: 20px;
        font-weight: 600;
        color: #181818;
      }
      .fun-wrap {
        width: 100%;
        padding: 25px 15px;
        margin-top: 25px;
        background: linear-gradient(
          180deg,
          rgba(245, 248, 250, 0.65) 0%,
          rgba(255, 255, 255, 0.75) 100%
        );
        box-shadow: 0px 7px 26px 0px rgba(191, 207, 203, 0.41),
          inset 0px 0px 0px 0px rgba(255, 255, 255, 0.5);
        border-radius: 15px;
        .module-wrap {
          position: relative;
          margin-bottom: 18px;
          &:last-child {
            margin-bottom: 0;
            &::after {
              height: 0;
            }
          }
          &::after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 1px;
            opacity: 0.56;
            transform: scaleY(0.7);
            background-color: #acc9c4;
          }
          .module-title {
            margin-bottom: 18px;
            font-size: 16px;
            font-weight: 500;
            color: #181818;
            padding-left: 9%;
          }
          .cell-wrap {
            flex-wrap: wrap;
            justify-content: flex-start;
            .cell {
              width: 33.33%;
              margin-bottom: 18px;
              text-align: center;
              img {
                width: 45px;
                height: 45px;
              }
              p {
                margin-top: 2px;
                font-size: 13px;
                color: #75818c;
                font-weight: 400;
              }
            }
          }
        }
      }
    }
  }
}
</style>
